import { useUI } from "@context/ui-managed-context";
import Button from "@elements/button";
// import Button from "@elements/redesign/Button/Button";
import CloseIcon from "@svg/closeIcon";
import { useTranslations } from "next-intl";
import { useRouter } from "next/router";

interface ChangePhoneNumberNoticeProps {

}

const ChangePhoneNumberNotice: React.FC<ChangePhoneNumberNoticeProps> = () => {
  const { setModalView, openModal, closeModal } = useUI()
  const t = useTranslations()
  const { locale } = useRouter()



  const handelClose = () => {
    closeModal()
  }
  const handelVerify = () => {
    setModalView("VERIFY_PHONE_NUMBER", false);
    openModal();
  }
  return (
    <div className="md:w-[480px] sm:w-screen xs:w-screen w-screen max-w-[480px] h-max" dir={locale?.includes("ar-") ? "rtl" : "ltr"}>
      <div className="w-full min-h-[282px] h-[max-content] bg-white rounded-3xl p-6 flex flex-col gap-3 items-center md:rounded-3xl rounded-b-none">
        <div className="w-full flex justify-end">
          <button className=" outline-none" onClick={() => handelClose()} >
            <CloseIcon />
          </button>
        </div>
        <div className="flex-1 flex flex-col gap-3 items-center justify-center w-full">
          <h3 className=" text-black text-xl font-normal leading-8 text-center">{t("client_phoneverify_settingchangenumbertitle")}</h3>
          <p className=" text-mui-text-secondary text-center text-sm font-medium leading-5 max-w-80 mt-2">{t("client_phoneverify_settingchangenumberdesc")}</p>
          <div className=" w-full grid grid-cols-1 gap-4 mt-10">
            <Button
              theme="blue"
              className="!font-bold !h-12 rounded-full text-sm "
              onClick={handelVerify}
            >
              {t("client_phoneverify_settingverifybadge")}
            </Button>
            {/* <Button theme="primaryOutline" label={t("client_buttons_exitanyway")} size="small" className=" !font-medium !h-12" onClick={handelClose} />
            <Button theme="primary" label={t("client_buttons_stayverify")} size="small" className=" !font-bold !h-12" onClick={handelVerify} /> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChangePhoneNumberNotice; 
